import { PractitionerForm } from "./practitioner.form";

export class PractitionerFormValidator {
  private errorMessage: string;

  constructor(private form: PractitionerForm) {}

  public isFormValid(): boolean {
    if (!this.form.getFormGroup().value.name) {
      this.errorMessage = "O campo Nome é obrigatório";
    } else if (!this.form.getFormGroup().value.stateAcronym) {
      this.errorMessage = "O campo UF é obrigatório";
    } else if (!this.form.getFormGroup().value.registration) {
      this.errorMessage = "O campo CRM é obrigatório";
    } else if (!this.form.getFormGroup().value.status) {
      this.errorMessage = "O campo Situação é obrigatório";
    }
    return !this.errorMessage;
  }

  public getErrorMessage(): string {
    return this.errorMessage;
  }
}
